/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Read_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not read the selected file." |
*
* @param {Datasets_Import_Csv_Read_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_read_error = /** @type {((inputs?: Datasets_Import_Csv_Read_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Read_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ausgewählte Datei konnte nicht gelesen werden.")
	return /** @type {LocalizedString} */ ("Could not read the selected file.")
});